var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import $request from '../../utils/request';
var state = {
    isShowDialog: false,
    editAuthDetail: [],
    showCheckBox: '',
    isShowCheckDialog: false,
    isShowAccountEditDialog: false,
    roleAuthAccount: [],
    allRoles: [],
    accountDetail: {},
    allAuth: [],
    checkHaveAuth: [],
    totalAccount: 0,
    allAccountCounts: 0,
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_ROLE_DETAIL: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 编辑角色权限 前获取角色权限详情
        $request({
            url: '/proxy/auth/role/tree',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                //TODO:待放开
                commit('update', {
                    editAuthDetail: res.data,
                    isShowDialog: true,
                });
            }
        });
    },
    GET_ROLE_AUTH_ACCOUNT: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 角色权限-查看账号
        params = Object.assign(params, {
            pageSize: 10000,
            pageNo: 1,
        });
        $request({
            url: '/proxy/auth/role/users',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    roleAuthAccount: res.data,
                    totalAccount: res.totalItemCount ? res.totalItemCount : 0,
                    isShowCheckDialog: true,
                });
            }
        });
    },
    GET_USER_INFO: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 用户账号-查看账号(编辑之前获取账户的详情)
        $request({
            url: '/proxy/auth/user/info/self',
            method: 'post',
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    accountDetail: res.data,
                });
            }
        });
    },
    GET_ACCOUNT_DETAIL: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 用户账号-查看账号(编辑之前获取账户的详情)
        $request({
            url: '/proxy/auth/user/info',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    accountDetail: res.data,
                    isShowAccountEditDialog: !params.type,
                });
            }
        });
    },
    GET_ALL_ROLES: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 获取全部角色
        $request({
            url: '/proxy/auth/role/all',
            method: 'POST',
            data: {
                pageNo: 1,
                pageSize: 10000,
            },
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    allRoles: res.data,
                });
            }
        });
    },
    get_ALL_AUTH: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 获取所有权限(添加角色调用)
        $request({
            url: '/proxy/auth/role/treeTenant',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    allAuth: res.data,
                });
            }
        });
    },
    CHECK_ROLE_AUTH: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 查看权限的时候调用
        $request({
            url: '/proxy/auth/role/treeHave',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    checkHaveAuth: res.data,
                    isShowDialog: true,
                });
            }
        });
    },
    GET_ALL_ACOUNTS: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 获取所有账户数
        $request({
            url: '/proxy/auth/user/count',
            method: 'post',
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    allAccountCounts: res.data,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
